import './App.css';
import { Routes, Route, Navigate, useLocation  } from "react-router-dom"
// Components
import SideMenu from './components/SideMenu/SideMenu';
// Pages
import VendorLogin from './pages/VendorLogin/VendorLogin';
import Login from './pages/Login/Login';
import DownloadByExcel from './pages/DownloadByExcel/DownloadByExcel';
import DownloadByDate from './pages/DownloadByDate/DownloadByDate';
import Users from './pages/Users/Users';
import Schools from './pages/SchoolsPages/Schools/Schools';
import Classroom from './pages/SchoolsPages/Classroom/Classroom';
import User from './pages/SchoolsPages/User/User';
import DownloadBySchool from './pages/DownloadBySchool/DownloadBySchool';   
import DownloadByClass from './pages/DownloadByClass/DownloadByClass';
import AddUser from './pages/AddUser/AddUser';
import VendorSchools from './pages/VendorSchools/VendorSchools';
import SchoolSetup from './pages/SchoolsPages/SchoolSetup/SchoolSetup';

// import { Rightcontent } from './components/Rightcontent.js';
import { CreateIdCard } from './pages/CreateIdCard/CreateIdCard';
import IdCards from './pages/CreateIdCard/IdCards';
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

import DownloadCards from './pages/DownloadCards/DownloadCards';

// Routes that vendors are not allowed to access
const restrictedRoutesForVendor = [
  '/idcards',
  '/users',
  '/download-by-date',
  '/download-by-school',
  '/download-by-class',
  '/download-by-excel',
  '/schools',
  // '/school-setup'
];

// Routes that schools are not allowed to access
const restrictedRoutesForSchool = [
  '/idcards',
  '/users',
  '/download-by-date',
  '/download-by-school',
  '/download-by-excel',
  '/schools',
  '/vendor-schools',
  '/school-setup'
];

function App() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const isPublicRoute = ['/add-user','/login','/vendor-login'].includes(location.pathname);
    
    // If a logged-in user hits a login page, clear session to log them out cleanly
    if (sessionStorage.getItem("ID_CardAdmin_user") && (location.pathname === '/login' || location.pathname === '/vendor-login')) {
      sessionStorage.removeItem('ID_CardAdmin_user');
      sessionStorage.removeItem('ID_CardAdmin_user_auth');
      sessionStorage.removeItem('ID_CardAdmin_user_role');
    }

    if (!sessionStorage.getItem("ID_CardAdmin_user") && !isPublicRoute) {
      const isVendorRoute = location.pathname.startsWith('/vendor-') || location.pathname === '/school-setup';
      const redirectPath = isVendorRoute ? '/vendor-login' : '/login';
      navigate(redirectPath, { replace: true, state: { from: location.pathname } });
    }
    
    // Redirect vendors away from restricted routes
    const isVendor = sessionStorage.getItem('ID_CardAdmin_user_role') === 'vendor';
    if (isVendor && restrictedRoutesForVendor.some(route => location.pathname.startsWith(route))) {
      navigate("/vendor-schools");
    }

    // Redirect schools away from admin-only routes
    const isSchool = sessionStorage.getItem('ID_CardAdmin_user_role') === 'school';
    if (isSchool && restrictedRoutesForSchool.some(route => location.pathname === route || (location.pathname.startsWith(route + '/') && !location.pathname.startsWith('/schools/')))) {
      navigate("/dashboard");
    }
  }, [location.pathname, navigate]);

  return (
    <div id="app">
      {/* <SideMenu /> */}
      {sessionStorage.getItem("ID_CardAdmin_user") && 
       !['/login', '/vendor-login', '/add-user'].includes(location.pathname) && 
       (location.pathname !== '/school-setup' || location.search.includes('view=admin')) && 
       <SideMenu />}
      <div className='app_routesCont' >
        <Routes>
          {/* <Route path="/right" element={<CreateIdCard />} /> */}
          <Route exact path="/" element={<Navigate to="/login" />} replace />
          <Route path="/vendor-login" element={<VendorLogin />} />
          <Route path="/login" element={<Login />} />
          <Route path="/add-user" element={<AddUser />} /> 
          <Route path="/school-setup" element={<SchoolSetup />} /> 
          <Route path="/dashboard" element={<Classroom />} />
          <Route path="/download-cards" element={<DownloadCards />} />
          <Route path="/idcards" element={<IdCards />} />
          <Route path="/idcards/:id" element={<CreateIdCard />} />
          <Route path="/users" element={<Users />} />
          <Route path="/download-by-date" element={<DownloadByDate />} />          
          <Route path="/download-by-school" element={<DownloadBySchool />} />
          <Route path="/download-by-class" element={<DownloadByClass />} />
          <Route path="/download-by-excel" element={<DownloadByExcel />} />
          {/* SchoolPages */}
          <Route path="/schools" element={<Schools />} />
          <Route path="/schools/:id" element={<Classroom />} />
          <Route path="/schools/class/:id" element={<User />} />
          {/* Vendor Routes */}
          <Route path="/vendor-schools" element={<VendorSchools />} />
          <Route path="/vendor-schools/:id" element={<Classroom />} />
          <Route path="/vendor-schools/class/:id" element={<User />} />
          <Route path="/add-user" element={<AddUser />} /> 
        </Routes>
      </div>
    </div>
  );
}

export default App;
